/** In-memory access token — not persisted to localStorage (P5-5). */
let accessToken: string | null = null;
let expiresAt = 0;

export function setAccessToken(token: string, expiresInSeconds: number): void {
  accessToken = token;
  expiresAt = Date.now() + expiresInSeconds * 1000;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function getTokenExpiration(): number {
  return expiresAt;
}

export function clearAccessToken(): void {
  accessToken = null;
  expiresAt = 0;
}

/** Clear legacy localStorage tokens from pre-cookie auth sessions. */
export function clearLegacyTokenStorage(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('tokenExpiration');
}
